import { render, staticRenderFns } from "./CategoryConfiguratorGeneral.vue?vue&type=template&id=a8a40d60&"
import script from "./CategoryConfiguratorGeneral.vue?vue&type=script&lang=js&"
export * from "./CategoryConfiguratorGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports